@if (header()) {
  <mat-list-item>
    <mat-icon
      class="igo-chevron"
      matListItemIcon
      igoCollapse
      [target]="filters"
      [collapsed]="filtersCollapsed"
      (click)="toggleFiltersCollapsed()"
    >
      expand_less
    </mat-icon>
    <span
      matListItemTitle
      (click)="toggleLegendOnClick()"
      [ngStyle]="{ cursor: filtersCollapsed ? 'default' : 'pointer' }"
      >{{ layer().title }}</span
    >
    @if (header()) {
      <button
        mat-icon-button
        matListItemMeta
        [color]="layer().visible ? 'primary' : 'default'"
        collapsibleButton
        tooltip-position="below"
        matTooltipShowDelay="500"
        [matTooltip]="
          layer().visible
            ? ('igo.geo.layer.hideLayer' | translate)
            : ('igo.geo.layer.showLayer' | translate)
        "
        (click)="toggleLayerVisibility()"
      >
        <mat-icon
          [ngClass]="{ disabled: (inResolutionRange$ | async) === false }"
          >{{ layer().visible ? 'visibility' : 'visibility_off' }}
        </mat-icon>
      </button>
    }
  </mat-list-item>
}

<div #filters class="igo-datasource-filters-container">
  <div #legend class="igo-layer-legend-container">
    @if (showLegend$ | async) {
      <igo-layer-legend [layer]="layer()" />
    }
  </div>
  <igo-time-filter-form
    [layer]="layer()"
    [options]="datasource.options.timeFilter"
    [currentValue]="datasource.options.params.TIME"
    (dateChange)="handleDateChange($event)"
    (yearChange)="handleYearChange($event)"
  />
</div>
